module.exports = __webpack_public_path__ + "static/media/edit-image-link.fee560fe.png";